// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
.body {
  height: 100vh;
  width: 100px;
  align-content: center;
  font-weight: 400;
  font-family: "Fira Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
label,
span {
  font-weight: 500;
  font-family: "Fira Sans", sans-serif;
}

body,
html,
.App,
#root,
.auth-wrapper {
  width: 100%;
  height: 100%;
}

.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}

.auth-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}

.auth-inner {
  max-width: 500;
  margin: auto;
  background: #ffffff;
  box-shadow: 10px 10px 30px 3px rgba(191, 191, 191, 1);
  padding: 40px 55px 45px 55px;
  border-radius: 8px;
  transition: all 0.3s;
}

.auth-wrapper .form-control:focus {
  border-color: #167bff;
  box-shadow: none;
}

.auth-wrapper h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}

.custom-control-label {
  font-weight: 400;
}

.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7f7d7d;
  margin: 0;
}

.forgot-password a {
  color: #167bff;
}
`, "",{"version":3,"sources":["webpack://./styles/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800\");\n\n* {\n  box-sizing: border-box;\n}\n.body {\n  height: 100vh;\n  width: 100px;\n  align-content: center;\n  font-weight: 400;\n  font-family: \"Fira Sans\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nlabel,\nspan {\n  font-weight: 500;\n  font-family: \"Fira Sans\", sans-serif;\n}\n\nbody,\nhtml,\n.App,\n#root,\n.auth-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.navbar-light {\n  background-color: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n}\n\n.auth-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: left;\n}\n\n.auth-inner {\n  max-width: 500;\n  margin: auto;\n  background: #ffffff;\n  box-shadow: 10px 10px 30px 3px rgba(191, 191, 191, 1);\n  padding: 40px 55px 45px 55px;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.auth-wrapper .form-control:focus {\n  border-color: #167bff;\n  box-shadow: none;\n}\n\n.auth-wrapper h3 {\n  text-align: center;\n  margin: 0;\n  line-height: 1;\n  padding-bottom: 20px;\n}\n\n.custom-control-label {\n  font-weight: 400;\n}\n\n.forgot-password,\n.forgot-password a {\n  text-align: right;\n  font-size: 13px;\n  padding-top: 10px;\n  color: #7f7d7d;\n  margin: 0;\n}\n\n.forgot-password a {\n  color: #167bff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
